(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-ba-pairs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cg-ba-slide')) {
    customElements.define('cg-ba-slide', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.knob = this.querySelector('.cg-ba-slide__knob');
        this.set(50);
        this.addEventListener('pointerdown', (e) => this.down(e));
        this.addEventListener('pointermove', (e) => this.move(e));
        this.addEventListener('pointerup', (e) => this.up(e));
        this.addEventListener('pointercancel', () => { this.drag = null; });
        this.addEventListener('dragstart', (e) => e.preventDefault());
        if (this.knob) this.knob.addEventListener('keydown', (e) => this.key(e));
      }
      at(e) {
        const r = this.getBoundingClientRect();
        return ((e.clientX - r.left) / r.width) * 100;
      }
      set(p) {
        p = Math.max(0, Math.min(100, p));
        this.pos = p;
        this.style.setProperty('--pos', p + '%');
        if (this.knob) {
          this.knob.setAttribute('aria-valuenow', Math.round(p));
          this.knob.setAttribute('aria-valuetext', '%' + Math.round(p));
        }
      }
      down(e) {
        if (e.button > 0) return;
        const touch = e.pointerType !== 'mouse';
        this.drag = { id: e.pointerId, x: e.clientX, y: e.clientY, on: !touch };
        // Fare: hemen sürükle. Dokunma: yönü belli olana kadar bekle; dikey hareket sayfayı kaydırır.
        if (!touch) {
          e.preventDefault();
          this.setPointerCapture(e.pointerId);
          this.set(this.at(e));
        }
      }
      move(e) {
        const d = this.drag;
        if (!d || e.pointerId !== d.id) return;
        if (!d.on) {
          const dx = Math.abs(e.clientX - d.x), dy = Math.abs(e.clientY - d.y);
          if (dx < 6 && dy < 6) return;
          if (dy > dx) { this.drag = null; return; }
          d.on = true;
          try { this.setPointerCapture(e.pointerId); } catch (err) {}
        }
        this.set(this.at(e));
      }
      up(e) {
        const d = this.drag;
        this.drag = null;
        // Dokunarak tek tıklama: tutamağı o noktaya taşı.
        if (d && !d.on && e.pointerId === d.id && Math.abs(e.clientX - d.x) < 6 && Math.abs(e.clientY - d.y) < 6) this.set(this.at(e));
      }
      key(e) {
        const k = e.key;
        let p = this.pos;
        if (k === 'ArrowLeft' || k === 'ArrowDown') p -= 5;
        else if (k === 'ArrowRight' || k === 'ArrowUp') p += 5;
        else if (k === 'PageDown') p -= 10;
        else if (k === 'PageUp') p += 10;
        else if (k === 'Home') p = 0;
        else if (k === 'End') p = 100;
        else return;
        e.preventDefault();
        this.set(p);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cg-before-after')) {
    customElements.define('cg-before-after', class extends HTMLElement {
      connectedCallback() {
        const r = this.querySelector('.cg-ba__range');
        if (!r) return;
        const set = () => this.style.setProperty('--pos', r.value + '%');
        r.addEventListener('input', set);
        set();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cg-sticky-atc')) {
    customElements.define('cg-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        this.mainBtn = document.querySelector('product-form button[name="add"][id^="ProductSubmitButton-"]');
        if (!this.mainBtn) return;
        this.btn = this.querySelector('.cg-sticky__btn');
        this.priceEl = this.querySelector('.cg-sticky__price');
        this.btn.addEventListener('click', () => {
          if (this.mainBtn.disabled) return;
          this.mainBtn.click();
        });
        // Yalnız ana buton ekranın ÜSTÜNDEN çıktıysa göster. IntersectionObserver yerine kaydırma kontrolü:
        // ana buton ilk ekranın altındayken en üste hızlı dönüşte IO yeni olay üretmiyor, çubuk açık kalıyordu.
        let queued = false;
        // BA-24: yalnız tema önizlemesinde (pencere sayfası) Shopify'ın alttaki önizleme çubuğu butonun üstüne biniyor,
        // dokunuş çubuğa gidiyordu. Çubuk varsa çubuğu onun üstüne kaldır; canlı sitede çubuk yok, davranış aynı.
        const lift = () => {
          if (!document.querySelector('.cg-pills--fix')) return; // BA-32: pencere + duşakabin
          const pb = document.getElementById('PBarNextFrameWrapper');
          const top = pb && pb.offsetHeight ? pb.getBoundingClientRect().top : window.innerHeight;
          const h = Math.max(0, Math.round(window.innerHeight - top));
          this.style.bottom = h ? h + 'px' : '';
          // BA-31: WhatsApp düğmesi çubuğun üstüne binmesin; çubuk görünürken onun 12 px yukarısına çıkar
          // (cg-pdp.css). Çubuk çizilmiyorsa (masaüstü) WhatsApp kendi yerinde kalır.
          const bar = this.offsetHeight;
          document.documentElement.style.setProperty('--cg-wa-lift', bar ? (h + bar + 12) + 'px' : '1.8rem');
        };
        const check = () => { queued = false; lift(); this.toggle(this.mainBtn.getBoundingClientRect().bottom < 0); };
        window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(check); } }, { passive: true });
        check();
        document.addEventListener('change', (ev) => {
          if (ev.target.closest('variant-selects, .product-form__quantity')) setTimeout(() => this.sync(), 400);
        });
      }
      sync() {
        // BA-27: paket kartlı sayfada (pencere) fiyatı kartlardaki seçimden, kartlarla aynı Türkçe biçimde yaz.
        const box = document.querySelector('.cg-pills--fix[data-cg-pills]'); // BA-32: duşakabin ölçü düğmeleri de
        const entry = box && box.cgEntry && box.cgMoney && box.cgEntry();
        if (entry) this.priceEl.textContent = box.cgMoney(entry.p);
        else {
          const p = document.querySelector('[id^="price-template--"] .price-item--sale, [id^="price-template--"] .price-item--regular');
          const sale = document.querySelector('[id^="price-template--"] .price--on-sale .price-item--sale');
          const src = sale || p;
          if (src && src.textContent.trim()) this.priceEl.textContent = src.textContent.trim();
        }
        this.btn.disabled = this.mainBtn.disabled;
        const t = this.mainBtn.querySelector('span');
        if (t && t.textContent.trim()) this.btn.textContent = t.textContent.trim();
      }
      toggle(show) {
        if (show === this.shown) return;
        this.shown = show;
        if (show) { this.sync(); this.hidden = false; this.removeAttribute('inert'); document.body.style.paddingBottom = this.offsetHeight + 'px'; }
        else { this.hidden = true; this.setAttribute('inert', ''); document.body.style.paddingBottom = ''; }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
